import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVideo: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="video, camera, movie, play"><path d="M15.5 9.875L21.25 7V17L15.5 14.125M2.75 4.75H15.25V19.25H2.75V4.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconVideo;
